const Obj = {
    copy(item: any){
        if (item) {
            return JSON.parse(JSON.stringify(item));
        }
    }
}
export default Obj;
